// extracted by mini-css-extract-plugin
export default {"subsection":"terms_subsection__VKMrr","section":"terms_section__xOvvE","heading":"terms_heading__cMXS-","main":"terms_main__PI3XU"};